const mutations = {
    setTaxList(state, data) {
        state.taxList = data;
    },
    setTax(state,data){
        state.tax=data;
    },
    resetTax(state){
        state.tax = {
            label : '',
            code : '',
            rate : ''
        }
    }
}

export default mutations;